import { Logo, scrollToSection } from "./Shared";

const NAV = [
  { label: "Markets", hash: "#markets" },
  { label: "Performance", hash: "#performance" },
  { label: "Membership", hash: "#pricing" },
  { label: "FAQ", hash: "#faq" },
];

const DESKS = ["Bursa Malaysia", "Forex & Comex", "SGX & Nasdaq", "HSI & IPO Access"];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-surface/60">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <Logo compact />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-500">
              Institutional-grade trading signals engineered for Malaysian and Singaporean traders.
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Navigate</p>
            <ul className="mt-4 space-y-2.5">
              {NAV.map((n) => (
                <li key={n.hash}>
                  <button
                    data-testid={`footer-link-${n.label.toLowerCase()}`}
                    onClick={() => scrollToSection(n.hash)}
                    className="text-sm text-slate-400 transition-colors hover:text-gold"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Desks</p>
            <ul className="mt-4 space-y-2.5">
              {DESKS.map((d) => (
                <li key={d} className="text-sm text-slate-400">{d}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 rounded-xl border border-line bg-obsidian/60 p-5">
          <p className="font-mono text-[10px] leading-relaxed text-slate-600">
            RISK DISCLAIMER: Trading in equities, forex, commodities and derivatives carries a high level of risk and may not be suitable for all investors. Past performance is not indicative of future results. Globex Sdn Bhd provides research-based trade recommendations only and does not guarantee profits. Capital targets shown (RM300 – RM10,000 per trade) are objectives, not promises. Never trade with funds you cannot afford to lose. Seek independent licensed advice where required under SC Malaysia or MAS regulations.
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-line pt-8 sm:flex-row">
          <p className="font-mono text-xs text-slate-600">&copy; 2026 Globex Sdn Bhd. All rights reserved.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">Kuala Lumpur &middot; Singapore</p>
        </div>
      </div>
    </footer>
  );
}
